import { CONSTANTS } from './constants'

export const getEligibleAgencies = (agencies, type, associatedAgencies) => {
  return type === CONSTANTS.AGENCY_TYPES.ASSOCIATED ? agencies : agencies.filter((agency) => !associatedAgencies.includes(agency.id))
}

export const isSectorDisabled = (type, agencies, associatedAgencies) => {
  return type !== CONSTANTS.AGENCY_TYPES.AVAILABLE ? false : agencies.every((agency) => associatedAgencies.includes(agency.id))
}
